<div
  (mouseenter)="item.selected = true"
  (mouseleave)="item.selected = false"
  class="d-flex flex-column"
>
  <div
    class="list-item menu-item col"
    (click)="item.selected = false"
    [style]="
      layoutMenu !== 2 ? 'padding: 4px;' : 'padding: 4px; padding-left:0'
    "
  >
    <div class="row menu-item">
      <div
        class="col-12 asd"
        [style]="layoutMenu !== 2 ? 'padding-left: 15px' : 'padding-left:0'"
      >
        <button
          data-toggle="collapse"
          style="
            background-color: transparent;
            padding-top: 0;
            text-align: center;
            padding-left: 0;
            padding-right: 0;
          "
          [style.text-align]="layoutMenu !== 2 ? 'center' : 'start'"
          type="button"
          (click)="select(item)"
          class="btn-panel panel-heading-drop {{
            item.selected ? '' : 'collapsed'
          }}"
        >
          {{ item.description }}
        </button>
      </div>
      <div class="col-2 list-item-icon">
        <div *ngIf="item.children.length; else quantityBlock">
          <a class="panel-heading collapsed"></a>
        </div>
        <ng-template #quantityBlock>
          <!-- <span class="badge badge-secondary">{{ item.quantity }}</span> -->
        </ng-template>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column">
    <div class="row justify-content-start" *ngFor="let i of item.children">
      <span class="subitem" (click)="selectSub(i, item.description)">{{
        i.description
      }}</span>
    </div>
  </div>
  <!-- <div
    *ngIf="item.children.length > 0"
    id="box{{ item.id }}"
    
    class="list-group list-group-flush panel-collapse collapse col {{
      item.selected ? 'show' : ''
    }}"
    style="position: absolute; margin-left: 240px;"
  >
    <div class="dropdown-box" style="padding: 0">
      <app-treeview-link-horizontal-opt2
        #submenu
        [selected]="i.selected"
        (onSelect)="onChildrenSelected($event)"
        *ngFor="let i of item.children"
        [item]="i"
        [parent]="parent + ' > ' + item.description"
        (breadCrumb)="saveBc($event)"
      ></app-treeview-link-horizontal-opt2>
    </div>
  </div> -->
</div>
